module.exports = __webpack_public_path__ + "static/media/flow-en.b5ea977d.png";